import type { ReactNode } from "react";

export function Panel({
  title,
  aside,
  annot,
  children,
  className = "",
}: {
  title?: ReactNode;
  aside?: ReactNode;
  annot?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`rounded-[var(--radius-card)] border border-border bg-bg ${className}`}
      data-annot={annot}
    >
      {title || aside ? (
        <div className="flex flex-wrap items-center gap-2 border-b border-border px-3 py-2">
          {title ? <h2 className="text-[13px] font-medium text-fg">{title}</h2> : null}
          {aside ? <div className="ml-auto flex flex-wrap items-center gap-2">{aside}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
